import { atomWithReset } from "jotai/utils";

export const claimHistoryReviewModalAtom = atomWithReset<{
  visible: boolean;
  claimId: string | null;
  isViewDetail?: boolean;
}>({
  visible: false,
  claimId: null,
  isViewDetail: false
});
